import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import AuthActions from 'actions/Auth';
import AuthStore from 'stores/Auth';
import AppPage from 'components/AppPage';
import Message from 'services/Message';
import LoginForm from 'components/LoginForm';
import FullScreenDialog from 'components/FullScreenDialog';
import Css from 'Css';
const { Units } = Css;

const css = oxygenCss({
  root: {
    paddintTop: Units.keyline,
    backgroundPosition: 'top left fixed',
    backgroundColor: 'transparent',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    boxSizing: 'initial'
  }
});

export default class Login extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func,
    media: PropTypes.string
  };

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  listenToActions() {
    this.listenToAction(AuthActions.loginSuccess, () => {
      const { params, location } = this.props;
      const { query } = location;
      if (params.hash) {
        return;
      }
      if (query && query.nextPath && query.nextPath !== '/logout') {
        this.props.router.replace(query.nextPath);
      } else {
        this.props.router.replace('/dashboard');
      }
    });
  }

  componentDidMount() {
    if (this.state.loggedIn) {
      this.props.router.replace(`/logged-in`);
    } else {
      AuthActions.tryHashLogin();
    }
  }

  onError(errorMessage) {
    Message.info(errorMessage);
  }

  handleSubmit(email, password) {
    AuthActions.login(email, password);
  }

  render() {
    return (
      <AppPage
        className={css.root}
        style={{ backgroundImage: `url('${require('library.jpg')}')` }}
      >
        <FullScreenDialog open mini toolbar={false} overlay={false} padded>
          <LoginForm
            router={this.props.router}
            loggingIn={this.state.loading}
            onSubmit={this.handleSubmit.bind(this)}
          />
        </FullScreenDialog>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Login.js